import { render, staticRenderFns } from "./BalanceOverview.vue?vue&type=template&id=ef1e2e78&scoped=true&"
import script from "./BalanceOverview.vue?vue&type=script&lang=js&"
export * from "./BalanceOverview.vue?vue&type=script&lang=js&"
import style0 from "./BalanceOverview.vue?vue&type=style&index=0&id=ef1e2e78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef1e2e78",
  null
  
)

export default component.exports